/**
 * VENDOR MODULES
 */
import React from 'react';

import { isFalsy } from 'shared/utils/common';
import Emitter     from 'shared/events/emitter';
import EVENT_NAMES from 'shared/constants/events';

import OverlayItem from 'features/video/components/overlays/OverlayItem';
import * as MediaEventStore from 'features/video/stores';

/**
 * Overlay container
 *
 * @class  OverlayContainer (name)
 * @return {DOM}
 */
function OverlayContainer(props) {
  const { video_id, scale_factor = 1 } = props;
  const [{ overlays = {} }] = MediaEventStore.useMediaEventContext();
  const overlay = overlays?.[video_id];
  const [time, setTime] = React.useState(0);

  React.useEffect(() => {
    if (!video_id) return () => {};
    setTime(0);
    const event_name_id = EVENT_NAMES.MEDIA.TIMEUPDATE_PROCEED + '-' + video_id;
    const handler = ({ time }) => {
      setTime(time);
    };
    Emitter.on(event_name_id, handler);
    return () => {
      Emitter.off(event_name_id, handler);
    };
  }, [video_id]);

  const overlay_htmls = !isFalsy(overlay)
    ? overlay
        .filter(({ start_time, end_time }) => parseFloat(start_time) <= time && parseFloat(end_time) >= time)
        .map((item, index) => <OverlayItem key={index} index={index} {...item} />)
    : [];

  return (
    <div
      className="video-overlay-wrapper"
      style={{zoom: scale_factor}}
    >
      {overlay_htmls}
    </div>
  );
}

export default OverlayContainer;

